import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectIsForceOpenedGlobalsModal = createSelector(
  [selectComposedReportState],
  ({ isForceOpenedGlobalsModal }) => isForceOpenedGlobalsModal
)
